import React, { Fragment, useRef, useLayoutEffect } from "react";
import "./DeleteAccount.scss";
import ButtonFooterLayout from "../buttonFooterLayout/ButtonFooterLayout";
import Banner from "../banner/banner";
import { bannerSentiment } from "../banner/bannerUtils";

import { ACCOUNT_DELETION_STATUSES } from "../../reducers/authenticationReducer";
import { withDefaults } from "../../utils/withDefaults";
import { useAppSelector } from "../../hooks";
import type { ButtonActivationEvent } from "../button/button";

export interface DeleteAccountProps {
  onCancelClick?: () => void;
  onDeleteAccountClick?: (uid: string) => void;
  uid: string;
}

export default function DeleteAccount(incomingProps: DeleteAccountProps) {
  const props = withDefaults(incomingProps, deleteAccountDefaultProps);

  const { accountDeletionStatus } = useAppSelector(state => state.login);

  const onConfirmButtonClick = (event: ButtonActivationEvent) => {
    event.preventDefault();
    props.onDeleteAccountClick(props.uid);
  };

  const cancelButtonRef = useRef<HTMLButtonElement | null>(null);

  useLayoutEffect(() => {
    if (cancelButtonRef.current) {
      cancelButtonRef.current.focus();
    }
  }, [cancelButtonRef]);

  return (
    <Fragment>
      {accountDeletionStatus === ACCOUNT_DELETION_STATUSES.FAILED ? (
        <Banner
          message="Error occurred deleting account. Error code: ERR03. Contact the Dashboi team at dashboi.app@gmail.com."
          sentiment={bannerSentiment.NEGATIVE}
        />
      ) : null}
      <p>We're sad to see you go!</p>
      <p>
        Deleting your account is permanent. Confirming deletion will remove your
        account as well as all data that you have entered, including your
        layouts, bookmarks and tasks.
      </p>
      <ButtonFooterLayout
        onSecondaryButtonClick={props.onCancelClick}
        onPrimaryButtonClick={onConfirmButtonClick}
        secondaryButtonText="Cancel"
        primaryButtonText="Delete"
        secondaryButtonRef={cancelButtonRef}
      />
    </Fragment>
  );
}

const deleteAccountDefaultProps = {
  onCancelClick: () => {},
  onDeleteAccountClick: () => {}
};
